import Image1 from "../images/kit-1.jpg";
import Image2 from "../images/kit-2.jpg";
import Image3 from "../images/kit-3.jpg";

const images = { Image1, Image2, Image3 };

export default images;
